<template>
  <TransitionGroup name="k-toast" tag="div" class="k-toast-stack">
    <KToast
      v-for="toast in toasts"
      :key="toast.id"
      class="k-toast-stack__item"
      :text="toast.text"
      :color="toast.color"
      :timeout="toast.timeout"
      :action-text="toast.actionText || ''"
      @close="$emit('close', toast.id)"
      @action="$emit('action', toast)"
    />
  </TransitionGroup>
</template>

<script>
import KToast from "@/components/ui/KToast";

export default {
  name: "KToastStack",
  components: { KToast },
  props: {
    toasts: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["close", "action"],
};
</script>

<style scoped>
.k-toast-stack {
  position: fixed;
  top: 84px;
  right: 16px;
  z-index: 2600;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  width: min(420px, calc(100vw - 32px));
  pointer-events: none;
}

.k-toast-stack__item {
  max-width: 100%;
}

.k-toast-enter-active {
  transition: transform var(--k-dur-slow) cubic-bezier(0.34, 1.56, 0.64, 1), opacity var(--k-dur-base) var(--k-ease-out);
}

.k-toast-leave-active {
  position: absolute;
  right: 0;
  transition: transform var(--k-dur-base) ease-in, opacity var(--k-dur-base) ease-in;
}

.k-toast-move {
  transition: transform var(--k-dur-slow) var(--k-ease-out);
}

.k-toast-enter-from {
  opacity: 0;
  transform: translateX(32px) scale(0.96);
}

.k-toast-leave-to {
  opacity: 0;
  transform: translateX(16px) scale(0.98);
}

@media (max-width: 599px) {
  .k-toast-stack {
    right: 16px;
    left: 16px;
    width: auto;
    align-items: stretch;
  }

  .k-toast-stack__item {
    width: auto;
  }

  .k-toast-leave-active {
    left: 0;
  }

  .k-toast-enter-from,
  .k-toast-leave-to {
    transform: translateY(-16px) scale(0.98);
  }
}

@media (prefers-reduced-motion: reduce) {
  .k-toast-enter-active,
  .k-toast-leave-active,
  .k-toast-move {
    transition: opacity var(--k-dur-fast);
  }

  .k-toast-enter-from,
  .k-toast-leave-to {
    transform: none;
  }
}
</style>
